module.exports = __webpack_public_path__ + "img/banner.aabcb922.jpg";